<template>
  <div class="page">
    This is home;
  </div>
</template>

<script>
export default {
  name: "home"
}
</script>

<style scoped>
.page {
  background-image: url("../../public/image/2f8a60915b923f8be7c510a322f8f534.jpg");
}
</style>